import type { SVGProps } from 'react'
const SvgSyFireFill = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M11.93 2.54C11.231 2.94 5.5 6.426 5.5 13a6.5 6.5 0 0 0 6 6.481v-4.615a1 1 0 1 1 1 0v4.615a6.5 6.5 0 0 0 6-6.48c0-6.574-5.731-10.06-6.43-10.462a.14.14 0 0 0-.14 0"
			clipRule="evenodd"
		/>
		<path d="M11.5 19.5V22h1v-2.5z" />
		<path
			fillRule="evenodd"
			d="M8.5 14a3.5 3.5 0 0 0 3 3.464v-2.598a1 1 0 1 1 1 0v2.598a3.5 3.5 0 0 0 3-3.464v-.026c-.011-4.519-2.88-6.988-3.415-7.41a.136.136 0 0 0-.17 0C11.38 6.987 8.5 9.465 8.5 14"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyFireFill
